<span *ngIf="checkCondition" class="list-item__action list-item__action--secondary">{{enabledText}}</span>
<span *ngIf="!checkCondition" class="list-item__action list-item__action--secondary">{{disabledText}}</span>
